module.exports = __webpack_public_path__ + "static/media/peixe-boi-partitura.f37ad27d.png";